import type { ComponentProps, ReactElement } from 'react'

import { isNil } from 'ramda'

import { BackButton } from '@twisto/components/atoms/back-button'
import { Flex } from '@twisto/components/atoms/flex'
import { Typography } from '@twisto/components/atoms/typography'
import type { RequireOnlyOne } from '@twisto/utils'

import { ModalCloser } from './modal-closer'
import * as styles from './modal-navigation.styles'

type BackButtonProps = RequireOnlyOne<
  {
    to: string
    onClick: () => void
  },
  'to' | 'onClick'
>

type Props = {
  title?: ReactElement | string
  sideContent?: ReactElement
  titleId?: string
  backButtonProps?: BackButtonProps
  label?: ReactElement | string
  modalCloser?: ComponentProps<typeof ModalCloser>
  noSeparator?: boolean
}
export const ModalNavigation = ({
  title,
  titleId,
  label,
  modalCloser: modalCloserProps,
  backButtonProps,
  noSeparator = false,
  sideContent,
}: Props) => (
  <Flex
    alignItems="center"
    css={[styles.navigation, !noSeparator && styles.separator]}
    data-testid="modal-navigation"
    justify="spaceBetween"
    wrap="noWrap"
  >
    <Flex alignItems="center" css={styles.adornment} justify="flexStart">
      {backButtonProps && (
        <BackButton {...backButtonProps} css={styles.backButton} />
      )}
      <div>
        {label !== undefined && (
          <Typography align="start" color="textSecondary" variant="b3">
            {label}
          </Typography>
        )}
        {title !== undefined && (
          <Typography
            align="start"
            color="textPrimary"
            fontWeight="medium"
            id={titleId}
            variant="b1"
          >
            {title}
          </Typography>
        )}
      </div>
      {!isNil(sideContent) && sideContent}
    </Flex>

    {!isNil(modalCloserProps) && (
      <ModalCloser position="relative" {...modalCloserProps} />
    )}
  </Flex>
)
